import { toast } from "react-toastify";
import { API_FACTURAS } from "../views/MainLayout/components/shared/services/facturas";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialFacturas = []

export const facturasReducer = (state = initialFacturas, action) => {
    switch(action.type){
        case "facturas/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchFacturas = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_FACTURAS.getFacturas(page, search)
        const data = await response.data;
        dispatch({ type: 'facturas/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}